document.addEventListener("DOMContentLoaded", function () {
  var toggle = document.querySelector(".vv-search-toggle");
  var panel = document.getElementById("vv-inline-search");
  var input = document.getElementById("vv-inline-search-input");
  if (!toggle || !panel || !input) return;
  toggle.addEventListener("click", function () {
    var opening = panel.hasAttribute("hidden");
    if (opening) {
      panel.removeAttribute("hidden");
      toggle.setAttribute("aria-expanded", "true");
      input.focus();
    } else {
      panel.setAttribute("hidden", "");
      toggle.setAttribute("aria-expanded", "false");
    }
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !panel.hasAttribute("hidden")) {
      panel.setAttribute("hidden", "");
      toggle.setAttribute("aria-expanded", "false");
      toggle.focus();
    }
  });
});
